// import utils
import { makeObservable, observable, action, computed, autorun } from "mobx";
import { NAVIGATION_RAIL_DRAWERWIDTH, NAVIGATION_RAIL_SUB_DRAWERWIDTH } from "../constants/navigationRail.consts.js";
const PIN_SWITCH_LOCAL_STORAGE_KEY = "navigation-rail-has-pin-switch";
class NavigationRailStore {
    isPinned = false;
    pinSwitch = true;
    constructor() {
        makeObservable(this, {
            isPinned: observable,
            pinSwitch: observable,
            setIsPinned: action,
            toggleIsPinned: action,
            pinnedRailWidth: computed,
            navigationRailWidth: computed,
            navigationRailSubWidth: computed,
        });
        if (typeof window === "undefined")
            return;
        const pinSwitchLocalStorage = localStorage.getItem(PIN_SWITCH_LOCAL_STORAGE_KEY);
        if (pinSwitchLocalStorage === null) {
            localStorage.setItem(PIN_SWITCH_LOCAL_STORAGE_KEY, "true");
        }
        else {
            this.pinSwitch = Boolean(pinSwitchLocalStorage);
        }
    }
    get pinnedRailWidth() {
        return this.navigationRailWidth + (this.isPinned ? this.navigationRailSubWidth : 0);
    }
    get navigationRailWidth() {
        return NAVIGATION_RAIL_DRAWERWIDTH;
    }
    get navigationRailSubWidth() {
        return NAVIGATION_RAIL_SUB_DRAWERWIDTH;
    }
    get pinActivated() {
        return localStorage.getItem(PIN_SWITCH_LOCAL_STORAGE_KEY) === "true";
    }
    setIsPinned = (isPinned) => {
        if (isPinned === this.isPinned)
            return;
        this.isPinned = !this.pinSwitch && isPinned;
    };
    toggleIsPinned = () => {
        this.setIsPinned(!this.isPinned);
    };
    setHasPinSwitch = (hasPinSwitch, isLargeScreen = true) => {
        if (hasPinSwitch === this.pinSwitch)
            return;
        if (this.isPinned && hasPinSwitch)
            this.isPinned = false;
        if (!this.isPinned && !hasPinSwitch)
            this.isPinned = true;
        if (typeof window !== "undefined" && isLargeScreen)
            localStorage.setItem(PIN_SWITCH_LOCAL_STORAGE_KEY, hasPinSwitch ? "true" : "");
        this.pinSwitch = this.pinActivated;
    };
    toggleHasPinSwitch = () => {
        this.setHasPinSwitch(!this.pinSwitch);
    };
}
export const navigationRailStore = new NavigationRailStore();
export default navigationRailStore;
// Util to make it easier to have none react elements react to changes in the store
export const togglePinnedClassNameUtil = (element, className = "") => {
    const toggleClass = () => {
        if (element)
            element.className = !navigationRailStore.pinSwitch && navigationRailStore.isPinned ? className : "";
    };
    autorun(toggleClass);
};
